import { LitElement, css } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import MarkdownIt from 'markdown-it';
import { shared } from './shared.ts';

// Raw HTML disabled: markdown-it escapes it. Its default validateLink blocks javascript:/data: URLs.
const md = new MarkdownIt({ html: false, linkify: false, typographer: true });

export function renderMarkdown(src: string): string {
  return md.render(src);
}

export class KaMarkdown extends LitElement {
  static override properties = { source: {} };
  declare source: string;
  static override styles = [
    shared,
    css`
      :host {
        max-width: 65ch;
      }
      blockquote {
        border-left: 4px solid var(--ka-stone-600);
        margin: 0 0 1em;
        padding-left: 1em;
      }
    `,
  ];
  constructor() {
    super();
    this.source = '';
  }
  override render() {
    return unsafeHTML(renderMarkdown(this.source));
  }
}
customElements.define('ka-markdown', KaMarkdown);
